"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISortBy = void 0;
var ISortBy;
(function (ISortBy) {
    ISortBy["Newest"] = "newest";
    ISortBy["TopRated"] = "topRated";
    ISortBy["Easiest"] = "easiest";
    ISortBy["Hardest"] = "hardest";
    ISortBy["Shortest"] = "shortest";
    ISortBy["Longest"] = "longest";
    ISortBy["Distance"] = "distance";
    ISortBy["Calories"] = "calories";
    ISortBy["Trending"] = "trending";
    ISortBy["Relevance"] = "relevance";
    ISortBy["Alphabetical"] = "alphabetical";
})(ISortBy || (exports.ISortBy = ISortBy = {}));
//# sourceMappingURL=sort-by.js.map